const APP_URL = "https://images.okepas.com";
const galleryContainer = document.getElementById("galleryContainer");
const loader = document.querySelector(".loading-images");

galleryContainer.addEventListener("click", async function (event) {
  if (event.target && event.target.matches(".add-button")) {
    const dataId = event.target.getAttribute("data-id");
    console.log("Data ID:", dataId);
    try {
      const button = event.target;
      const loader = button.nextElementSibling;
      loader.style.display = "block";
      const response = await fetch(`https://images.okepas.com/download`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ assetId: dataId }),
      });

      if (!response.ok) {
        loader.style.display = "none";
        throw new Error(
          `Failed to send data to the API. Status: ${response.status}`
        );
      }

      const data = await response.json();

      if (data.status) {
        loader.style.display = "none";

        const countryMap = {
          CA: "ca",
          EU: "eu",
          AT: "eu",
          AU: "au",
        };

        let country = countryMap[Shopify.country] || "eu";

        const url = `https://okepas.com/en-${country}/products/okepas-custom-sneaker?pattern=${data.filePath}`;
        window.open(url, "_blank");
      }

      if (!data.status) {
        loader.style.display = "none";
        alert(data.message);
      }
    } catch (error) {
      loader.style.display = "none";
      console.error("Error:", error);
    }
  }
});

document.addEventListener("DOMContentLoaded", async () => {
  const customerId = ShopifyAnalytics.meta?.page?.customerId;
  if (!customerId) {
    const wishlist = await getWishlistFromCookies();

    if (wishlist.length > 0) {
      wishlist.forEach((fav) => {
        const imgElement = document.createElement("span");
        imgElement.className = "gallery-item image-container";
        imgElement.innerHTML = `
          <div class="wishlist-icon active" data-id="${fav.image_id}">❤️</div>
          <img src="${fav.image_src}" alt="Favourite image" />
          <button class="add-button" data-id="${fav.image_id}">Add</button>
          <div class="loader" style="display: none;"></div>
        `;
        galleryContainer.appendChild(imgElement);

        imgElement.querySelector(".wishlist-icon").addEventListener("click", () => {
          removeFromWishlistCookies(fav.image_id);
          imgElement.remove(); // Remove from UI too
        });
      });
    } else {
      galleryContainer.innerHTML = "<p>Please log in to view your favourites.</p>";
    }

    loader.style.display = "none";
    return;
  }

  loader.style.display = "block";

  try {
    const response = await fetch(`${APP_URL}/api/favourites?user_id=${customerId}`);
    const data = await response.json();
    const images = data.data;

    loader.style.display = "none";

    if (!images || images.length === 0) {
      galleryContainer.innerHTML = "<p>You have no favourite images yet.</p>";
      return;
    }

    images.forEach((fav) => {
      const imgElement = document.createElement("span");
      imgElement.className = "gallery-item image-container";
      imgElement.innerHTML = `
        <div class="wishlist-icon active" data-id="${fav.image_id}">❤️</div>
      <img src="${fav.image_src}" alt="Favourite image" />
      <button class="add-button" data-id="${fav.image_id}">Add</button>
      <div class="loader" style="display: none;"></div>
      `;
      galleryContainer.appendChild(imgElement);
      imgElement.querySelector('.wishlist-icon').addEventListener('click', () => {
        removeFromWishlist(fav.image_id, customerId);
      });
    });
  } catch (error) {
    loader.style.display = "none";
    console.error("Failed to load favourites:", error);
    galleryContainer.innerHTML = "<p>Error loading favourites.</p>";
  }
});

function removeFromWishlist(assetId, customerId) {
  if (!confirm("Are you sure you want to remove this from your favourites?")) return;
  const icon = document.querySelector(`.wishlist-icon[data-id="${assetId}"]`);
  const span = icon.closest("span");
  const perImageLoader = span.querySelector(".loader");
  perImageLoader.style.display = "block";

  const url = `${APP_URL}/api/favourites/delete/${assetId}?user_id=${customerId}`;
  fetch(url, {
    method: 'GET',
    headers: {'Content-Type': 'application/json'},
  })
  .then(res => res.json())
    .then(data => {
      perImageLoader.style.display = "none";
      const countEl = document.getElementById("wishlist-count");
      if (data.status) {
        document.querySelector(`.wishlist-icon[data-id="${assetId}"]`).closest("span").remove();
        if (countEl && data.count !== undefined) {
          countEl.textContent = data.count;
        }
        alert("Removed from favourites");
      } else {
        alert("Failed to remove");
      }
    })
    .catch(err => {
      perImageLoader.style.display = "none";
      console.error("Remove failed:", err);
      alert("Something went wrong");
    });
}

function removeFromWishlistCookies(assetId) {
  const wishlist = getWishlistFromCookies().filter(item => item.image_id !== assetId);
  document.cookie = `wishlist=${encodeURIComponent(JSON.stringify(wishlist))}; path=/; max-age=${60 * 60 * 24 * 30}`;
  const countEl = document.getElementById("wishlist-count");
        if (countEl) {
          countEl.textContent = wishlist.length;
        }
}

function getWishlistFromCookies() {
  const cookie = document.cookie
    .split("; ")
    .find(row => row.startsWith("wishlist="));
  if (!cookie) return [];
  try {
    return JSON.parse(decodeURIComponent(cookie.split("=")[1]));
  } catch (e) {
    console.error("Invalid wishlist cookie:", e);
    return [];
  }
}